<script setup lang="ts">
import OrganizationView from '@/components/Organization/OrganizationView.vue'
import {
    ADMIN_ORGANIZATION_API_HREF,
    ADMIN_ORGANIZATION_DEVICE_HREF,
    ADMIN_ORGANIZATION_NETWORKS_HREF,
    ADMIN_ORGANIZATION_USER_HREF,
    ADMIN_ORGANIZATION_USER_ROUTES
} from '@/router/routing/adminRouting/adminRoutes'
import store from '@/store'
import { EOrganizationActions } from '@/store/organizationStore/OrganizationStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { defaultOrganizationModel, type OrganizationModel } from '@/types/models/OrganizationModel'
import {
    EAdminOrganizationDevicesTabPerm,
    EAdminOrganizationInformationsTabPerm,
    EAdminOrganizationNetworksTabPerm,
    EAdminOrganizationsApisTabPerm,
    EAdminOrganizationUsersTabPerm
} from '@/types/permissions/AdminPermissionsEnum'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const organizationStore = computed(() => store.state.organization)
const organizationId = ref(route.params.id?.toString())
const isLoading = ref(false)

const getOrganization = () => {
    store
        .dispatch(
            `${EStoreModules.ORGANIZATION}/${EOrganizationActions.FETCH_ORGANIZATION}`,
            organizationId.value
        )
        .then(res => (organizationValue.value = res))
        .finally(() => (isLoading.value = false))
}

onMounted(() => {
    if (typeof organizationId.value === 'string') getOrganization()
})

const organizationValue = ref<OrganizationModel>({ ...defaultOrganizationModel })

const goToCreate = () =>
    router.push(ADMIN_ORGANIZATION_USER_ROUTES(parseInt(organizationId.value)).createUrl)
const goToDetail = (userId: number) =>
    router.push(ADMIN_ORGANIZATION_USER_ROUTES(parseInt(organizationId.value)).buildUrl(userId))
</script>

<template>
    <OrganizationView
        :data="organizationValue"
        :isLoading="organizationStore.isLoading"
        @goToDetail="goToDetail"
        @goToCreate="goToCreate"
        @refresh="getOrganization()"
        :informationsPermission="EAdminOrganizationInformationsTabPerm"
        :usersViewPermission="EAdminOrganizationUsersTabPerm"
        :usersViewButtonsHref="ADMIN_ORGANIZATION_USER_HREF(parseInt(organizationId))"
        :networksViewPermission="EAdminOrganizationNetworksTabPerm"
        :networksViewButtonsHref="ADMIN_ORGANIZATION_NETWORKS_HREF(parseInt(organizationId))"
        :devicesViewPermission="EAdminOrganizationDevicesTabPerm"
        :devicesViewButtonsHref="ADMIN_ORGANIZATION_DEVICE_HREF(parseInt(organizationId))"
        :apisViewPermission="EAdminOrganizationsApisTabPerm"
        :apisViewButtonsHref="ADMIN_ORGANIZATION_API_HREF(parseInt(organizationId))"
        showDevices />
</template>
